import React, { useEffect, useState } from "react";
import {
  calculateDateRangeFromDate,
  roundOffValue,
  roundToTwoDecimalPlaces,
} from "../../../../../../Utils/DateConverstion";
import { Button, Modal, Card } from "antd";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { useStoreUpdaterWithAPI } from "../../../../../../Hooks/UseStoreUpdaterWithApi";
import { APIConstants } from "../../../../../../Common/APIConstants";

const getModulePath = (path) => {
  console.log(path);
  // if (path.includes("steam-dashboard")) return "steam-dashboard";
  if (path.includes("electrical-dashboard")) return "electrical-dashboard";
  // if (path.includes("temperature-dashboard")) return "temperature-dashboard";
  // if (path.includes("air-dashboard")) return "air-dashboard";
  // if (path.includes("water-dashboard")) return "water-dashboard";
  return "";
};

// const parameters = [
//     {
//         "parameterid": 1,
//         "parametername": "VR"
//     },
//     {
//         "parameterid": 2,
//         "parametername": "VY"
//     },
//     {
//         "parameterid": 3,
//         "parametername": "VB"
//     },
//     {
//         "parameterid": 4,
//         "parametername": "F"
//     },
//     {
//         "parameterid": 5,
//         "parametername": "VRY"
//     },
//     {
//         "parameterid": 6,
//         "parametername": "VYB"
//     },
//     {
//         "parameterid": 7,
//         "parametername": "VBR"
//     },
//     {
//         "parameterid": 8,
//         "parametername": "VLLAvg"
//     },
//     {
//         "parameterid": 9,
//         "parametername": "IR"
//     },
//     {
//         "parameterid": 10,
//         "parametername": "IY"
//     },
//     {
//         "parameterid": 11,
//         "parametername": "IB"
//     },
//     {
//         "parameterid": 12,
//         "parametername": "IAVG"
//     },
//     {
//         "parameterid": 13,
//         "parametername": "Vunb"
//     },
//     {
//         "parameterid": 14,
//         "parametername": "Iunb"
//     },
//     {
//         "parameterid": 15,
//         "parametername": "KWT"
//     },
//     {
//         "parameterid": 16,
//         "parametername": "KVAT"
//     },
//     {
//         "parameterid": 17,
//         "parametername": "KVART"
//     },
//     {
//         "parameterid": 18,
//         "parametername": "PFT"
//     },
//     {
//         "parameterid": 19,
//         "parametername": "PFR"
//     },
//     {
//         "parameterid": 20,
//         "parametername": "PFY"
//     },
//     {
//         "parameterid": 21,
//         "parametername": "PFB"
//     },
//     {
//         "parameterid": 22,
//         "parametername": "KWR"
//     },
//     {
//         "parameterid": 23,
//         "parametername": "KWY"
//     },
//     {
//         "parameterid": 24,
//         "parametername": "KWB"
//     },
//     {
//         "parameterid": 25,
//         "parametername": "KVA_R"
//     },
//     {
//         "parameterid": 26,
//         "parametername": "KVA_Y"
//     },
//     {
//         "parameterid": 27,
//         "parametername": "KVA_B"
//     },
//     {
//         "parameterid": 28,
//         "parametername": "KVAR_R"
//     },
//     {
//         "parameterid": 29,
//         "parametername": "KVAR_Y"
//     },
//     {
//         "parameterid": 30,
//         "parametername": "KVAR_B"
//     },
//     {
//         "parameterid": 31,
//         "parametername": "KWD"
//     },
//     {
//         "parameterid": 32,
//         "parametername": "KVAD"
//     },
//     {
//         "parameterid": 33,
//         "parametername": "KWHTotal"
//     },
//     {
//         "parameterid": 34,
//         "parametername": "kWhImport"
//     },
//     {
//         "parameterid": 35,
//         "parametername": "KWHEXPORT"
//     },
//     {
//         "parameterid": 36,
//         "parametername": "kVAh"
//     },
//     {
//         "parameterid": 37,
//         "parametername": "kVArhTotal"
//     },
//     {
//         "parameterid": 38,
//         "parametername": "kVArhinductive"
//     },
//     {
//         "parameterid": 39,
//         "parametername": "KVARHCAPACITIVE"
//     },
//     {
//         "parameterid": 40,
//         "parametername": "V_THDAvg"
//     },
//     {
//         "parameterid": 41,
//         "parametername": "V_THDR"
//     },
//     {
//         "parameterid": 42,
//         "parametername": "V_THDY"
//     },
//     {
//         "parameterid": 43,
//         "parametername": "V_THDB"
//     },
//     {
//         "parameterid": 44,
//         "parametername": "I_THDAvg"
//     },
//     {
//         "parameterid": 45,
//         "parametername": "I_THDR"
//     },
//     {
//         "parameterid": 46,
//         "parametername": "I_THDY"
//     },
//     {
//         "parameterid": 47,
//         "parametername": "I_THDB"
//     }
// ]

export const ElectricalMeterGrid = ({sectionId, report, selected, setSelected ,converterGroupId}) => {
  const navigate = useNavigate();
  const { makeRequest } = useStoreUpdaterWithAPI(); 
  const location = useLocation();
  const [selectedReport, setSelectedReport] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedParameters, setSelectedParameters] = useState([
    "VR",
    "VB",
    "F",
    "VY",
    "VRY",
    "VYB",
    "VBR",
    "VLLAvg",
    "IR",
    "IY",
    "IB",
    "IAVG",
    "Vunb",
    "Iunb",
    "KWT",
    "KVAT",
    "KVART",
    "PFT",
    "PFR",
    "PFB",
    "KWR",
    "KWY",
    "KWB",
    "KVA_R",
    "KVA_Y",
    "KVA_B",
    "KVAR_Y",
    "KVAR_B",
    "KWD",
    "KVAD",
    "KWHTotal",
    "kWhImport",
    "KWHEXPORT",
    "kVAh",
    "kVArhTotal",
    "kVArhinductive",
    "KVARHCAPACITIVE",
    "V_THDAvg",
    "V_THDR",
    "V_THDY",
    "V_THDB",
    "I_THDAvg",
    "I_THDR",
    "I_THDY",
    "I_THDB",
  ]);
  const modulePath = getModulePath(location.pathname);
  const [selectedValues, setSelectedValues] = useState(["IAVG"]);
  const [parameters, setParameters] = useState([]);
  const [title, setTitle] = useState('Title')
  function extractSiteNameAndMeterId(data) {
    console.log(data)
    const currentDate = new Date();
    const { from, to } = calculateDateRangeFromDate(currentDate, 15, 2);
    return {
      SectionID: sectionId,
      ConverterorGroupID: converterGroupId,
      SiteName: data.SiteName,
      MeterIds: sectionId ==1? data.MeterId:data.AutoID,
      FromDate: from,
      ToDate: to,
    };
  }
  const showModal = (item) => {
    console.log(item);
    fetchparamters(extractSiteNameAndMeterId(item));
    const paraData = extractSiteNameAndMeterId(item);
    console.log("first");
    console.log(paraData);
  setSelectedReport(paraData);
    setIsModalVisible(true);
    // navigate(`/${modulePath}/meter-status/meter-status-popup`);
  };

  const handleCancel = () => {
    setSelectedReport(null);
    setIsModalVisible(false);
    // navigate(`/${modulePath}/meter-status`);
  };
  console.log(report);
  console.log(converterGroupId);

  // useEffect(()=>{
  //     setSelected(!selected);
  // },[report])

  const mode = useSelector((state) => state.darkMode);
  const { isdarkMode } = mode;

  // const filteredReport =
  //   report && Array.isArray(report)
  //     ? report.map((item) => {
  //         const filteredItem = {};
  //         selectedParameters.forEach((param) => {
  //           // Filter parameters, but exclude "IAVG" based on selectedValues
  //           if (
  //             item[param] !== undefined &&
  //             (param !== "IAVG" || selectedValues.includes("IAVG"))
  //           ) {
  //             filteredItem[param] = item[param];
  //           }
  //         });
  //         return { ...item, parameters: filteredItem };
  //       })
  //     : [];

  const filteredReport =
  report && Array.isArray(report)
    ? report.map((item) => {
        const filteredItem = {};
        let status = "idle"; // Default status is "off"

        // Loop through selectedParameters to filter parameters
        selectedParameters.forEach((param) => {
          // Check if the parameter exists in the item and apply conditions for "IAVG"
          if (
            item[param] !== undefined &&
            (param !== "IAVG" || selectedValues.includes("IAVG"))
          ) {
            filteredItem[param] = item[param];
          }
        });

        // Determine the status based on IAVG and kWh total
        const iavg = item["IAVG"] || 0; // Default to 0 if IAVG is undefined
        const kWhImport = item["kWhImport"] || 0; // Default to 0 if kWh total is undefined

        if (iavg === 0 && kWhImport === 0) {
          status = "off"; // Both IAVG and kWh total are zero -> "off"
        } else if (iavg > 0 && kWhImport === 0) {
          status = "idle"; // IAVG has a value but kWh total is zero -> "idle"
        } else if (iavg > 0 && kWhImport > 0) {
          status = "on"; // Both IAVG and kWh total have values -> "on"
        }

        // Return the transformed item with the additional status
        return { ...item, parameters: filteredItem, status };
      })
    : [];


  console.log(selected);



  const getParameterDisplay = (paramValue) => {
    if (paramValue > 0) {
      return { display: `${roundOffValue(paramValue)}`, borderColor: "green" };
    } else if (paramValue === 0) {
      return { display: `${roundOffValue(paramValue)}`, borderColor: "yellow" };
    } else if (paramValue < 0) {
      return {
        display: `${roundOffValue(paramValue)}`,
        borderColor: "#f44336",
      };
    } else {
      return { display: `${roundOffValue(paramValue)}`, borderColor: "yellow" };
    }
  };
  console.log(selectedReport);

  const fetchparamters = (input) => {
    // setIsLoading(true);
    console.log(input);
    const url = `${APIConstants.ELECTRICAL_PARAMETER_VIEW}?SectionID=${input.SectionID}&ConverterorGroupID=${input.ConverterorGroupID}&MeterIds=${input.MeterIds}&FromDate=${input.FromDate}&Todate=${input.ToDate}`;
    console.log("URL :", url);

    makeRequest({
      type: APIConstants.GET,
      url: url,
    })
      .then((res) => {
        console.log("Meter Data:", res);
        console.log(extractKeyValuePairs(res))
        setParameters(extractKeyValuePairs(res));
        setTitle(res)
      })
      .catch((error) => {
        console.error("Error fetching meter data:", error);
      });
  };

  const mapResponse = (responseArray) => {
    // Helper function to find parameter value by name
    const getValue = (name) => {
      const parameter = responseArray.find(item => item.parametername.toLowerCase() === name.toLowerCase());
      return parameter ? parameter.value : 0;
    };
  
    // Map the response to the required format
    return {
      KWH: getValue('kwhTotal'),
      PF: getValue('pft'),
      VLL: getValue('vllAvg'),
      IAvg: getValue('iavg'),
      meterId: getValue('meterId'), // Assuming a static meter ID for now
      VRY: getValue('vry'),
      VYB: getValue('vyb'),
      VBR: getValue('vbr'),
      avgVLL: getValue('vllAvg'),
      kVA1: getValue('kvaR_R'),
      kVA2: getValue('kvA_Y'),
      kVA3: getValue('kvaR_B'),
      kVAT: getValue('kvat'),
      kW1: getValue('kwr'),
      kW2: getValue('kwy'),
      kW3: getValue('kwb'),
      kWT: getValue('kwt'),
      kVAR1: getValue('kvarr'),
      kVAR2: getValue('kvaR_Y'),
      kVAR3: getValue('kvarb'),
      kVART: getValue('kvart'),
      VR: getValue('vr'),
      VY: getValue('vy'),
      VB: getValue('vb'),
      I1: getValue('ir'),
      I2: getValue('iy'),
      I3: getValue('ib'),
      KWh: getValue('kWhImport'),
      KVAh: getValue('kVAh'),
      KVARhTotal: getValue('kVArhTotal'),
      KWHEXPORT: getValue('kwhexport'),
      lastPollTime: new Date().toLocaleString(), // Placeholder for current time
    };
  };
  const extractKeyValuePairs = (data) => {
    // Destructure the first object in data
    const dataObject = data["0"];

    // List of keys to exclude
    const excludeKeys = ["siteName", "metername","createdOn"];

    // Create an array of objects with key-value pairs
    const keyValuePairs = Object.keys(dataObject)
      .filter((key) => !excludeKeys.includes(key)) // Exclude the keys that are in excludeKeys
      .map((key) => ({
        parametername: key, // Using the key as the parametername
        value: dataObject[key], // The corresponding value for that key
      }));

      const res = mapResponse(keyValuePairs)
    return res;
  };

  console.log(selectedParameters)

  const data = {
    KWH: 11158.8,
    PF: 1,
    VLL: 189.24,
    IAvg: 0,
    meterId: 1,
    VRY: 283.08,
    VYB: 0,
    VBR: 284.65,
    avgVLL: 189.24,
    kVA1: 0,
    kVA2: 0,
    kVA3: 0,
    kVAT: 0,
    kW1: 0,
    kW2: 0,
    kW3: 0,
    kWT: 0,
    kVAR1: 0,
    kVAR2: 0,
    kVAR3: 0,
    kVART: 0,
    VR: 230.96,
    VY: 82.32,
    VB: 82.31,
    I1: 0,
    I2: 0,
    I3: 0,
    KWh: 11158.8,
    KVAh: 13715.37,
    KVARhTotal: 8603.731,
    KWHEXPORT: -7144.18,
    lastPollTime: '12/26/2024 9:28:00 AM',
  };
  console.log(parameters)
  console.log(filteredReport);
  return (
    <div className={`flex px-2 py-2 flex-wrap w-fit gap-3 rounded-md`}>
      {filteredReport.length === 0 ? (
        <p
          className={`${!isdarkMode ? "text-black" : "text-white"} text-2xl text-center`}
        >
          No Data Available
        </p>
      ) : (
        filteredReport.map((item) => {
          return (
            <Card
              key={item?.MeterId}
              onClick={() => showModal(item)}
              className={`min-w-[250px] my-1 mx-1 rounded-md text-center shadow-2xl ${isdarkMode ? "ant-card-background " : "whitemode"}`}
              headStyle={{
                backgroundColor:`${item.status==='off'?"red":item.status==='on'?"green":item.status==='idle'?'yellow':''}`,
              }}
              title={
                <p
                  className="py-2 h-auto font-bold"
                  style={{
                    backgroundColor: `${item.status==='off'?"red":item.status==='on'?"green":item.status==='idle'?'yellow':''}`,
                    margin: 0,
                    padding: "5px 0",
                  }}
                >
                  {item?.METERNAME}
                </p>
              }
            >
              <p
                className={`h-auto pb-5 font-bold text-black ${isdarkMode ? "ant-card-body-padding" : "whitemode"}`}
                style={{
                  borderBottomWidth: "2px",
                  borderBottom: `${item.status==='off'?" 2px solid red":item.status==='on'?"2px solid green":item.status==='idle'?'2px solid yellow':''}`,
                  // borderBottom: `2px solid ${borderColor}`,
                }}
              >
                Meter ID: {roundToTwoDecimalPlaces(item?.MeterId)}
              </p>

              <div
                className={`space-y-3 h-auto font-bold text-black ${isdarkMode ? "ant-card-body-padding" : "whitemode"}`}
              >
                {Object.keys(item.parameters).map((paramKey) => {
                  if (
                    paramKey !== "IAVG" ||
                    (paramKey === "IAVG" && selected)
                  ) {
                    const paramValue = item.parameters[paramKey];
                    return (
                      <p
                        key={paramKey}
                        className="border-b-2 my-3 h-auto pb-2 w-full"
                        style={{
                          borderBottomWidth: "2px",
                          borderBottom: `${item.status==='off'?" 2px solid red":item.status==='on'?"2px solid green":item.status==='idle'?'2px solid yellow':''}`,
                        }}
                      >
                        {paramKey} : {roundOffValue(paramValue)}
                      </p>
                    );
                  }
                  return null;
                })}
              </div>
            </Card>
          );
        })
      )}

<Modal
  open={isModalVisible}
  onCancel={handleCancel}
  closable={false}
  className={`custom-modal custom-card ${isdarkMode ? "custom-modal-dark" : "whitemode"}`}
  footer={null}
  width={1000}
  style={{ top: 0, textAlign: "center" }} // Adjust 'top' to set vertical position
  bodyStyle={{ textAlign: "center" }} // Center the content
  title={
    <div
      style={{
        padding: 5,
        borderRadius: "8px 8px 0 0",
      }}
      className={`gap-3 flex justify-between ${
        isdarkMode ? "text-white bg-[#1F2A40]" : "text-black "
      }`}
    >
      <p
        className={`border-b-2 px-2 border-blue-500 ${
          isdarkMode ? "text-white" : "text-black"
        }`}
      >
      Meter ID : {parameters.meterId||"N/A"}
      </p>
      <p>
        {title[0]?.metername || "N/A"}
      </p>
      <p>
        Last Poll Time: {title[0]?.createdOn?.replace("T", " ") || "N/A"}
      </p>
    </div>
  }
>
  <div
    className={`text-center font-bold ${
      isdarkMode ? "text-white" : "text-black border-2 rounded-md"
    }`}
  >
    <Card
      className={`custom-card  border rounded-lg shadow-lg p-0 ${
        isdarkMode ? "bg-[#1F2A40] text-white" : "bg-white text-black"
      }`}
    >
      {/* Dashboard Content */}
      <div className="dashboard"> 
        {/* <div className="header">
          <h2 className={`${isdarkMode ? "text-white" : "text-black"} font-bold`}>
            Live Values
          </h2>
          <h2 className={`${isdarkMode ? "text-white" : "text-black"} font-bold`}>
            Meter ID : {parameters.meterId}
          </h2>
        </div> */}
        <div className="content grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {/* Main Parameters */}
          <div
            className={`box main-parameters p-3 rounded-2xl shadow-xl ${
              isdarkMode ? "bg-gray-700 text-white" : "bg-[#1a1a3d] text-white "
            }`}
          >
            <h3>Main Parameters</h3>
            <p>KWH: {parameters.KWH}</p>
            <p>PF: {parameters.PF}</p>
            <p>V LL: {parameters.VLL}</p>
            <p>I Avg: {parameters.IAvg}</p> 
          </div>
          {/* Meter ID */}
          {/* <div
            className={`box meter-id p-3 rounded-lg ${
              isdarkMode ? "bg-gray-700 text-white" : "bg-[#1a1a3d] text-white "
            }`}
          >
            <h3>Meter ID</h3>
            <h1>{parameters.meterId}</h1>
          </div> */}
          {/* Voltage Line to Line */}
          <div
            className={`box voltage-line-to-line p-3 rounded-lg ${
              isdarkMode ? "bg-gray-700 text-white" : "bg-[#1a1a3d] text-white "
            }`}
          >
            <h3>Voltage Line to Line</h3>
            <p>VRY: {parameters.VRY}</p>
            <p>VYB: {parameters.VYB}</p>
            <p>VBR: {parameters.VBR}</p>
            <p>Avg VLL: {parameters.avgVLL}</p>
          </div>
          {/* Apparent Power */}
          <div
            className={`box apparent-power p-3 rounded-lg ${
              isdarkMode ? "bg-gray-700 text-white" : "bg-[#1a1a3d] text-white "
            }`}
          >
            <h3>Apparent Power</h3>
            <p>kVA1: {parameters.kVA1}</p>
            <p>kVA2: {parameters.kVA2}</p>
            <p>kVA3: {parameters.kVA3}</p>
            <p>kVAT: {parameters.kVAT}</p>
          </div>
          {/* Active Power */}
          <div
            className={`box active-power p-3 rounded-lg ${
              isdarkMode ? "bg-gray-700 text-white" : "bg-[#1a1a3d] text-white "
            }`}
          >
            <h3>Active Power</h3>
            <p>kW1: {parameters.kW1}</p>
            <p>kW2: {parameters.kW2}</p>
            <p>kW3: {parameters.kW3}</p>
            <p>kWT: {parameters.kWT}</p>
          </div>
          {/* Reactive Power */}
          <div
            className={`box reactive-power p-3 rounded-lg ${
              isdarkMode ? "bg-gray-700 text-white" : "bg-[#1a1a3d] text-white "
            }`}
          >
            <h3>Reactive Power</h3>
            <p>kVAR1: {parameters.kVAR1}</p>
            <p>kVAR2: {parameters.kVAR2}</p>
            <p>kVAR3: {parameters.kVAR3}</p>
            <p>kVART: {parameters.kVART}</p>
          </div>
          {/* Voltage */}
          <div
            className={`box voltage p-3 rounded-lg ${
              isdarkMode ? "bg-gray-700 text-white" : "bg-[#1a1a3d] text-white "
            }`}
          >
            <h3>Voltage</h3>
            <p>VR: {parameters.VR}</p>
            <p>VY: {parameters.VY}</p>
            <p>VB: {parameters.VB}</p>
          </div>
          {/* Current */}
          <div
            className={`box current p-3 rounded-lg ${
              isdarkMode ? "bg-gray-700 text-white" : "bg-[#1a1a3d] text-white "
            }`}
          >
            <h3>Current</h3>
            <p>I1: {parameters.I1}</p>
            <p>I2: {parameters.I2}</p>
            <p>I3: {parameters.I3}</p>
            <p>I Avg: {parameters.IAvg}</p>
          </div>
          {/* Energies */}
          <div
            className={`box energies p-3 rounded-lg ${
              isdarkMode ? "bg-gray-700 text-white" : "bg-[#1a1a3d] text-white "
            }`}
          >
            <h3>Energies</h3>
            <p>KWh: {parameters.KWh}</p>
            <p>KVAh: {parameters.KVAh}</p>
            <p>KVARh Total: {parameters.KVARhTotal}</p>
            <p>KWHEXPORT: {parameters.KWHEXPORT}</p>
          </div>
          {/* Time */}
          {/* <div
            className={`box time p-3 rounded-lg ${
              isdarkMode ? "bg-gray-700 text-white" : "bg-[#1a1a3d] text-black"
            }`}
          >
            <h3>Time</h3>
            <p>Last Poll Time: {title[0]?.createdOn?.replace("T", " ")}</p>
          </div> */}
        </div>
      </div>
    </Card>
  </div>

  <div className="flex w-full justify-end mt-5">
    <button
      className="mr-5 mb-5 bg-blue-500 text-white rounded-md px-5 py-2"
      onClick={handleCancel}
    >
      Close
    </button>
  </div>
</Modal>

    </div>
  );
};


//       <Modal
//         open={isModalVisible}
//         onCancel={handleCancel}
//         closable={false}
//         className={`custom-modal ${isdarkMode ? "custom-modal-dark custom-modal-header" : "whitemode"}`}
//         footer={null}
//         width={800}
//         style={{ padding: 0 }}
//         title={
//           <div
//             style={{
//               padding: 5,
//               borderRadius: "8px 8px 0 0",
//             }}
//             className={` ${isdarkMode ? "text-white" : "whitemode"} gap-3 flex justify-between`}
//           >
//             <p className={`border-b-2 px-2   ${isdarkMode ? "text-white" : "whitemode"} border-blue-500 `}>
//             {title[0]?.metername} 
//             </p>
//             <p> 
//             Last Poll Time : {title[0]?.createdOn?.replace('T',' ')}
//             </p>
//           </div>
//         }
//       >
//         <div
//           style={{ padding: 5 }}
//           className={`text-center font-bold ${isdarkMode ? "text-white" : "whitemode"} `}
//         >
// <Card className={`h-[400px] overflow-auto p-4 border rounded-lg shadow-md ${isdarkMode ? "custom-modal-dark custom-modal-header" : "whitemode"}`}>
//   {/* Flex container */}
//   {/* <div className="flex flex-wrap gap-4">
//     {parameters.map((item, index) => (
//       <div
//         key={index} // Unique key for each item
//         className={`flex-1 min-w-[180px] max-w-[220px] border-2 border-blue-400 p-2 rounded ${isdarkMode ? "text-white" : "whitemode"}`}
//       >
//         <strong>{item.parametername || "N/A"}:</strong>
//         <span className="ml-2">{item.value !== undefined ? item.value : "N/A"}</span>
//       </div>
//     ))}
//   </div> */}
//   <div className="dashboard">
//       <div className="header">
//         <h2>Live Values</h2>
//       </div>
//       <div className="content">
//         <div className="box main-parameters">
//           <h3>Main Parameters</h3>
//           <p>KWH: {parameters.KWH}</p>
//           <p>PF: {parameters.PF}</p>
//           <p>V LL: {parameters.VLL}</p>
//           <p>I Avg: {parameters.IAvg}</p>
//         </div>
//         <div className="box meter-id">
//           <h3>Meter ID</h3>
//           <h1>{parameters.meterId}</h1>
//         </div>
//         <div className="box voltage-line-to-line">
//           <h3>Voltage Line to Line</h3>
//           <p>VRY: {parameters.VRY}</p>
//           <p>VYB: {parameters.VYB}</p>
//           <p>VBR: {parameters.VBR}</p>
//           <p>Avg VLL: {parameters.avgVLL}</p>
//         </div>
//         <div className="box apparent-power">
//           <h3>Apparent Power</h3>
//           <p>kVA1: {parameters.kVA1}</p>
//           <p>kVA2: {parameters.kVA2}</p>
//           <p>kVA3: {parameters.kVA3}</p>
//           <p>kVAT: {parameters.kVAT}</p>
//         </div>
//         <div className="box active-power">
//           <h3>Active Power</h3>
//           <p>kW1: {parameters.kW1}</p>
//           <p>kW2: {parameters.kW2}</p>
//           <p>kW3: {parameters.kW3}</p>
//           <p>kWT: {parameters.kWT}</p>
//         </div>
//         <div className="box reactive-power">
//           <h3>Reactive Power</h3>
//           <p>kVAR1: {parameters.kVAR1}</p>
//           <p>kVAR2: {parameters.kVAR2}</p>
//           <p>kVAR3: {parameters.kVAR3}</p>
//           <p>kVART: {parameters.kVART}</p>
//         </div>
//         <div className="box voltage">
//           <h3>Voltage</h3>
//           <p>VR: {parameters.VR}</p>
//           <p>VY: {parameters.VY}</p>
//           <p>VB: {parameters.VB}</p>
//         </div>
//         <div className="box current">
//           <h3>Current</h3>
//           <p>I1: {parameters.I1}</p>
//           <p>I2: {parameters.I2}</p>
//           <p>I3: {parameters.I3}</p>
//           <p>I Avg: {parameters.IAvg}</p>
//         </div>
//         <div className="box energies">
//           <h3>Energies</h3>
//           <p>KWh: {parameters.KWh}</p>
//           <p>KVAh: {parameters.KVAh}</p>
//           <p>KVARh Total: {parameters.KVARhTotal}</p>
//           <p>KWHEXPORT: {parameters.KWHEXPORT}</p>
//         </div>
//         <div className="box time">
//           <h3>Time</h3>
//           <p>Last Poll Time: {title[0]?.createdOn?.replace('T',' ')}</p>
//         </div>
//       </div>
//     </div>
// </Card>
//         </div>

//         <div className="flex w-full justify-end mt-5">
//           <button
//             className="mr-5 mb-5 bg-blue-500 text-white rounded-md px-5 py-2"
//             onClick={handleCancel}
//           >
//             Close
//           </button>
//         </div>
//       </Modal>